{
    "common": {
        "yes": "Yes",
        "no": "No",
        "cancel": "Cancel",
        "ok": "Ok",
        "close": "Close",
        "save": "Save",
        "add": "Add",
        "edit": "Edit",
        "delete": "Delete",
        "error": "Error",
        "delete_confirm": "Are you sure to delete?",
        "search": "Search",
        "search_placeholder": "Search...",
        "select": "Select",
        "select_all": "Select All",
        "no_data_found": "No data found",
        "success": "Success",
        "confirmation": "Confirmation"
    },
    "topBar": {
        "dark_mode": "Dark Mode",
        "logout": "Logout",
        "profile": "Profile",
        "light_mode": "Light Mode",
        "site_title": "Operational Dashboard"
    },
    "menuItems": {
        "admin_panel": "Admin Panel",
        "dashboard": "Dashboard",
        "users": "Users",
        "menus": "Menus",
        "settings": "Settings",
        "profile": "Profile",
        "logout": "Logout"
    },
    "login": {
        "welcome": "Welcome",
        "subtitle": "Please login to continue",
        "email": "Email Address",
        "email_required": "Email address is required",
        "email_invalid": "Please enter a valid email address",
        "username": "Username",
        "username_required": "Username is required",
        "enter_username": "Please enter a username",
        "password": "Password",
        "password_required": "Password is required",
        "password_min": "Your password should be at least 8 characters",
        "login": "Login",
        "login_success": "Login successful"
    }
}
